import appleTrust from "@assets/app_store_app_of_the_day_2023_black.webp"
import appleLogo from "@assets/applestore.webp"
import googleTrust from "@assets/google_editors_choice_2023_black.webp"
import googleLogo from "@assets/googleplaystore.webp"
import StarRating from "@components/StarRating"
import { useTranslation } from "react-i18next"

export default function Trust() {
  const { t } = useTranslation()

  const testimonials = [
    {
      text: t("pages.onboarding.plans.trust_element.testimonial1"),
      author: t("pages.onboarding.plans.trust_element.testimonial1Author"),
    },
    {
      text: t("pages.onboarding.plans.trust_element.testimonial2"),
      author: t("pages.onboarding.plans.trust_element.testimonial2Author"),
    },
    {
      text: t("pages.onboarding.plans.trust_element.testimonial3"),
      author: t("pages.onboarding.plans.trust_element.testimonial3Author"),
    },
  ]

  return (
    <div className="space-y-8 text-center">
      <div className="space-y-6">
        <h2 className="custom-heading">
          {t("pages.onboarding.plans.trust_element.testimonialsHeading")}
        </h2>

        <div className="grid gap-4 sm:grid-cols-1 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="rounded-2xl border border-gray-200 bg-white p-6 text-left shadow-sm"
            >
              <div className="mb-3">
                <StarRating rating={5} />
              </div>
              <p className="mb-4 text-sm leading-relaxed text-gray-700">
                {testimonial.text}
              </p>
              <p className="font-bold text-black">{testimonial.author}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col items-center rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
          <div className="mb-2 flex items-center gap-2 sm:mb-3">
            <span className="text-3xl font-bold text-blue-600 sm:text-4xl md:text-5xl">
              {t("pages.onboarding.plans.trust_element.appStoreRating")}
            </span>
            <img
              src={appleLogo}
              alt="App Store"
              className="h-8 w-8 sm:h-10 sm:w-10"
            />
          </div>
          <div className="mb-2">
            <StarRating rating={4.5} />
          </div>
          <p className="text-center text-xs text-gray-500 sm:text-sm">
            {t("pages.onboarding.plans.trust_element.appStoreRatingsCount")}
          </p>
        </div>

        <div className="flex flex-col items-center rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
          <div className="mb-2 flex items-center gap-2 sm:mb-3">
            <span className="text-3xl font-bold text-green-600 sm:text-4xl md:text-5xl">
              {t("pages.onboarding.plans.trust_element.googlePlayRating")}
            </span>
            <img
              src={googleLogo}
              alt="Google Play"
              className="h-8 w-8 sm:h-10 sm:w-10"
            />
          </div>
          <div className="mb-2">
            <StarRating rating={4.5} />
          </div>
          <p className="text-center text-xs text-gray-500 sm:text-sm">
            {t("pages.onboarding.plans.trust_element.googlePlayRatingsCount")}
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <p className="custom-heading">
          {t("pages.onboarding.plans.trust_element.heading")}
        </p>

        <div className="flex justify-center space-x-4">
          <img
            src={appleTrust}
            alt="App Store App of the Day 2023"
            className="h-auto w-40"
          />
          <img
            src={googleTrust}
            alt="Google Editors' Choice 2023"
            className="h-auto w-40"
          />
        </div>

        <p className="text-lg">
          {t("pages.onboarding.plans.trust_element.andHas")}
        </p>

        <p className="text-2xl font-bold">
          {t("pages.onboarding.plans.trust_element.userAmount")}
        </p>

        <div className="flex justify-center">
          <StarRating rating={5} />
        </div>
      </div>
    </div>
  )
}
